export enum FILTER {
  OPEN = 'OPEN',
  REGIONALPOOL = 'REGIONALPOOL',
  PENDING = 'PENDING',
  ALL = 'ALL'
}
